import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { compose, withProps } from 'recompose';

import { Paragraph, Text } from 'components/core/Typography';
import { Tooltip } from 'components/core/Tooltip';

import DropdownIcon from 'components/svg/Dropdown';

import './FeeWarningToolTip.scss';

export const enhance = compose(
	withProps(({ facility }) => ({
		fees: [
			{
				name: 'One-Time Admin Fee',
				price: facility.adminFee,
			},
			{
				name: 'One-Time Lock Fee',
				price: facility.lockFee,
			},
		],
		totalFees: facility.totalFees,
	})),
);

export function FeeWarningToolTip({ fees, totalFees, className }) {
	return (
		<Tooltip
			className={classnames('tooltip-banner', className)}
			content={
				<Paragraph
					size="tiny"
					color="gray"
				>
					The following fees shall apply:
					<ul>
						{fees.map(
							(fee) =>
								fee.price > 0 && (
									<li
										key={fee.name}
										className="fee-item"
									>
										{`${fee.name}: $${fee.price}`}
									</li>
								),
						)}
					</ul>
				</Paragraph>
			}
		>
			<Text
				last
				size="tiny"
				color="gray"
			>
				+ ${totalFees} in fees
				<DropdownIcon />
			</Text>
		</Tooltip>
	);
}

FeeWarningToolTip.propTypes = {
	fees: PropTypes.arrayOf(
		PropTypes.shape({
			name: PropTypes.string,
			price: PropTypes.number,
		}),
	).isRequired,
	totalFees: PropTypes.number.isRequired,
	className: PropTypes.string,
};

export default enhance(FeeWarningToolTip);
